import { ADMIN_ROLE_NAME, StandardUserRoles } from './enums';

const SaaSViewerRoles = [StandardUserRoles.DEFAULT];
const SaaSAdminRoles = [...SaaSViewerRoles, ADMIN_ROLE_NAME];

const FlashViewerRoles = [StandardUserRoles.DEFAULT];
const FlashAdminRoles = [...FlashViewerRoles, ADMIN_ROLE_NAME];

export const SaaSGroupedRoles = {
    viewer: {
        roles: SaaSViewerRoles,
    },
    admin: {
        roles: SaaSAdminRoles,
    },
};

export const FlashGroupedRoles = {
    viewer: {
        roles: FlashViewerRoles,
    },
    admin: {
        roles: FlashAdminRoles,
    },
};
